export const DEFAULT_PRODUCT_CATEGORY_SLUG = "product";